import React from 'react';
import ChatMessenger from '../../components/Messenger';
import { AWSStatusIndicator } from '../../components';

const AiMessenger: React.FC = () => {
  // Note: ChatMessenger can work without userId for admin usage
  return (
    <>
      <AWSStatusIndicator />
      <ChatMessenger userId={null} />
    </>
  );
};

export { AiMessenger };
